import theme from 'theme';

const COLORS = {
  black1: '#081320',
  black2: '#000915',
  blue1: '#153D66',
  blue2: '#212E76',
  blue3: '#0160F8',
  purple1: '#28002E',
  purple2: '#1A0937',
  gray1: '#39424D',
  gray2: '#979797',
};

const global = {
  header1: {
    fontSize: 58,
    lineHeight: '72px',
    letterSpacing: '-1px',
  },
  header2: {
    fontSize: 48,
    lineHeight: '58px',
    letterSpacing: '-0.55px',
  },
  header3: {
    fontSize: 28,
    lineHeight: '36px',
    letterSpacing: '-0.39px',
  },
  header4: {
    fontSize: 24,
    lineHeight: '32px',
    letterSpacing: '-0.39px',
  },
  paragraph1: {
    fontSize: 18,
    lineHeight: '28px',
    letterSpacing: '-0.22px',
  },
  paragraph2: {
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '-0.1px',
  },
} as const;

const common = {
  header: {
    ...global.header2,
    fontWeight: 800,
    color: 'white',
  },
  paragraph: {
    ...global.paragraph1,
    color: 'white',
  },
  paragraph2: {
    ...global.paragraph2,
    color: 'white',
  },
  subheader: {
    ...global.header3,
    color: 'white',
  },
  keyPoint: {
    ...global.header4,
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  keyPointIcon: {
    fontSize: 8,
    color: 'white',
  },
};

export { COLORS, global, common };
